import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { GenericResponse } from "src/app/shared/interfaces/generic.interface";
import { environment as env } from "src/environments/environment";
import { MarkCard, dataToCreateMarkAttendance, dataToUpdateMarkAttendance } from "../interfaces/mark.interface";
import { map} from 'rxjs/operators';
import { REFRESH_INDEXED } from "src/app/core/indexedDB/helpers/enums.enums";
import { IndexedDBDexieService } from "src/app/core/indexedDB/service/indexed-db-dexie.service";
import { localDB } from "src/app/shared/helpers/localStorage";
import { CollaboratorMarksRecomendedWrapperResponse } from "../interfaces/marks-recommended.interface";


@Injectable({
  providedIn: "root",
})
export class MarkingService {
  estatusMarcacion: "" | "Puntual" | "Tardanza" = "";

  public reloadMark = new BehaviorSubject<boolean>(false)
  public $reloadMarks = this.reloadMark.asObservable()

  constructor(
    private readonly http: HttpClient,
    private readonly _indexDB: IndexedDBDexieService
    )
  {}

  createMarkNew(data: any): Observable<any> {
    return this.http.post<any>(env.api_url + "api/marcas/crearMarca", data); 
  }

  getRedButton(): Observable<any> {
    return this.http.get<any>(env.api_url + "api/marcas/marca4").pipe(
      map(res => {
        localDB.removeItem('extemp_data');
        localDB.setItem('extemp_data', JSON.stringify(res))
        return res
      })
    );
  }

  extemporaneousMark(fecha_marca: Date): Observable<any> {
    return this.http.get<any>(
      env.api_url  + "api/marcacion/marcasFaltantes?dDate_Mark=" + fecha_marca
    );
  }

  listMarks(fecha_marca?: string): Observable<any> {
    if(fecha_marca){
      return this.http.get<GenericResponse<MarkCard[]>>(
        env.api_url  + "api/marcacion/marksDayBefore?dDate_Mark=" + fecha_marca
      );
    }else{
      return this._indexDB.getRequestData<GenericResponse<MarkCard[]>>('api/marcacion/marksDayBefore?dDate_Mark=', 'endpoints', REFRESH_INDEXED.EVERY_DAY)
    }
  }

  requestListExtempMarks(fechas: { fechaInicio: string, fechaFin: string}) {
    return this._indexDB.getRequestData<any>("api/marcas/listExtemByUser", 'endpoints', REFRESH_INDEXED.EVERY_DAY, {dataPost:fechas})
  }

  attendanceMarkCreate(data: dataToCreateMarkAttendance): Observable<any> {
    return this.http.post<any>(env.api_url + "api/marcacion/CrearMarcaAsistencia", data);
  }

  attendanceMarkEdit(data: dataToUpdateMarkAttendance): Observable<any> {
    return this.http.post<any>(env.api_url + "api/marcacion/EditarMarcaAsistencia", data);
  }

  attendanceMarkDelete(data: dataToUpdateMarkAttendance): Observable<any> {
    return this.http.post<any>(env.api_url + "api/marcacion/EliminarMarcaAsistencia", data);
  }

  getMarksRecomended(fecha: string): Observable<GenericResponse<CollaboratorMarksRecomendedWrapperResponse>> {
    return this.http.get<GenericResponse<CollaboratorMarksRecomendedWrapperResponse>>(
      `${env.api_url}api/marcas/marks-recomended?dfechaJornada=${fecha}`
    );
  }
}
